export default (theme) => ({
  // A date and its time share a line while both fit, and take a line each on a narrow screen.
  rootContainer: {
    flex: '1 1 160px',
    padding: '0 10px',
  },
  dateColumn: {
    flexBasis: 210,
  },
  label: {
    marginBottom: 4,
    display: 'flex',
    flexDirection: 'column',
  },
  // The date opens the dialog's own calendar, so its input only displays the value.
  dateContainer: {
    cursor: 'pointer',
    '& input': {
      pointerEvents: 'none',
    },
  },
  timeField: {
    margin: '8px 0',
  },
  error: {
    color: theme.palette.textColor.red,
    padding: '0 5px',
    fontSize: 11,
  },
});
